import React from 'react';

/**
 * Lade-Platzhalter im Layout der SessionCard (Badges, Titel, Text, Footer).
 * Wird beim Erstbesuch der SessionsPage angezeigt, solange noch keine
 * gecachten Sessions vorliegen - statt eines Full-Page-Spinners.
 *
 * Bewusst von Hand nachgebaut statt ueber `ui/Skeleton`: Der Platzhalter soll die
 * ECHTE Karte nachzeichnen, damit beim Umschalten nichts springt. Ein generischer
 * Baustein waere hier ein Rueckschritt (so auch im Modernisierungsplan, P1.3).
 * Radius und Schatten folgen seit August 2026 `ui/Card` - vorher rounded-2xl +
 * rohes shadow-lg, wodurch der Platzhalter groesser wirkte als die Karte danach.
 */
const SessionCardSkeleton = () => (
  <div
    data-testid="session-card-skeleton"
    className="bg-surface/80 rounded-xl shadow-token-sm border border-border overflow-hidden animate-pulse"
    aria-hidden="true"
  >
    <div className="p-4 sm:p-5 space-y-3">
      {/* Meta-Zeile: Status- und Typ-Badges */}
      <div className="flex items-center justify-between gap-2">
        <div className="h-6 w-16 rounded-full bg-surface-raised" />
        <div className="flex items-center gap-1.5">
          <div className="h-6 w-16 rounded-full bg-surface-raised" />
          <div className="h-6 w-12 rounded-full bg-surface-raised" />
        </div>
      </div>

      {/* Titel */}
      <div className="h-5 w-2/3 rounded bg-surface-raised" />

      {/* Beschreibung */}
      <div className="space-y-2">
        <div className="h-3.5 w-full rounded bg-surface-raised" />
        <div className="h-3.5 w-4/5 rounded bg-surface-raised" />
      </div>

      {/* Ort & Zeit */}
      <div className="flex items-center gap-4">
        <div className="h-3.5 w-24 rounded bg-surface-raised" />
        <div className="h-3.5 w-20 rounded bg-surface-raised" />
      </div>

      {/* Footer: Button-Platzhalter */}
      <div className="h-10 w-full rounded-xl bg-surface-raised" />
    </div>
  </div>
);

export default SessionCardSkeleton;
